import * as React from 'react';
import Scrollbar from 'perfect-scrollbar-react';

export interface IPerfectScrollbarProps {
    className: string;
}

export class PerfectScrollbar extends React.PureComponent<IPerfectScrollbarProps, {}> {
    constructor(props: IPerfectScrollbarProps) {
        super(props);
    }

    public render() {
        return <div style={{ display: 'flex' }} className={this.props.className} >
            <Scrollbar>
                {this.props.children}
            </Scrollbar>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/PerfectScrollbar.tsx